var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#176dff",
    d: "M17 2H1a1 1 0 010-2h16a1 1 0 011 1zm-4 4H5a1 1 0 010-2h8a1 1 0 011 1zM8 9a1 1 0 111 1z"
  })));
}
export default __webpack_public_path__ + "static/svg/filters-icon.svg";
export { SvgFiltersIcon as ReactComponent };